module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrolledSections"
  }, _vm._l((_vm.sections), function(section, index) {
    return (!section.fullSection) ? _c('div', {
      key: section,
      staticClass: "scrolledSections-section",
      class: {
        'm-current': _vm.currentSection == index, 'm-prev': _vm.currentSection > index, 'm-next': _vm.currentSection < index
      }
    }, [(section.scrolledSection) ? _c(section.scrolledSection.sectionType + '', {
      tag: "component",
      attrs: {
        "data": section.scrolledSection.data,
        "sharedData": section.sharedData
      }
    }) : _vm._e()], 1) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378b3100","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/globalBlocks/ScrolledSections.vue
// module id = 549
// module chunks = 0